import { message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useStore } from '../../../../mobx-store/context'
import ResourceModal from '../ResourceAccessModal/resourceModal'
import { Button, Wrap } from './style'

const TabsNav = ({
  tabs,
  active = 'tracking',
  styleWrap,
  allowResource,
  onRedirectTo,
  noCheck,
}) => {
  const store = useStore()
  const history = useHistory()
  const params = useParams()
  const [visible, setVisible] = useState(false)
  const [modalData, setModalData] = useState({})

  const user = store.user?.[0]
  const company = store.company?.[0]

  const accessCheck = () => {
    if (
      user &&
      company &&
      (!user?.have_access_to_tracking || !company?.have_access_to_tracking) &&
      (!user?.have_access_to_resource || !company?.have_access_to_resource)
    ) {
      message.error("You don't have access to any mode")
      history.push('/edit-profile')
    }

    if (
      active === 'tracking' &&
      (!user?.have_access_to_tracking || !company?.have_access_to_tracking)
    ) {
      onRedirectTo('resource')
    }

    if (
      active === 'resource' &&
      (!user?.have_access_to_resource || !company?.have_access_to_resource)
    ) {
      onRedirectTo('tracking')
    }
  }

  const onClick = (item, e) => {
    if (
      noCheck ||
      ((user?.member_type === 'admin' || user?.resource_role === 'admin') &&
        company['have_access_to_' + item])
    )
      return
    if (
      item === 'resource' &&
      (!user.have_access_to_resource || !company.have_access_to_resource) &&
      !allowResource
    ) {
      setModalData({
        to:
          user?.member_type === 'admin'
            ? company.have_access_to_resource
              ? `/edit-team-members-profile/${user.id}/resource`
              : '/resource/options'
            : '/edit-profile',
        type: 'resource',
      })
      setVisible(true)
      e.preventDefault()
      return
    } else if (
      item === 'tracking' &&
      (!user.have_access_to_tracking || !company.have_access_to_tracking)
    ) {
      setVisible(true)
      setModalData({
        type: 'tracking',
        to:
          store.user[0]?.member_type === 'admin' ? '/pricing' : '/edit-profile',
      })
      e.preventDefault()
      return
    }
  }

  const onClose = () => setVisible(false)

  useEffect(() => {
    if (!noCheck) accessCheck()
  }, [user])

  return (
    <Wrap style={styleWrap}>
      {visible && <ResourceModal onClose={onClose} {...modalData} />}
      {Object.entries(tabs).map((item) => (
        <Button
          to={item[1].link}
          key={item[0]}
          active={active === item[0]}
          onClick={(e) => onClick(item[0], e)}
        >
          {item[1].button}
        </Button>
      ))}
    </Wrap>
  )
}

export default TabsNav
